
// components/Loader.js
import React from 'react';
import { AiOutlineLoading3Quarters } from 'react-icons/ai';
import '../styles/Loader.css';

const Loader = () => {
  return (
    <div className="loader-wrapper">
      <AiOutlineLoading3Quarters className="spinner-icon" />
    </div>
  );
};

export default Loader;
